function initDsoForm() {
    if (!document.querySelector('.js-dso-form')) return;

    const form = document.querySelector('.js-dso-form');

    new ValidateForm(form);

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // const res = await fetch(form.action)

        const res = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form)
        })

        const data = await res.json();

        if (!res.ok) {
            switch (window.lang) {
                case 'en': {
                    modalMessage('An error has occurred', 'Refresh the page or try again later');
                    break;
                }
                default: {
                    modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
                }
            }
            return;
        }

        YaMetrika.regGuaranteeTrigger();

        if (data.data?.redirect) {
            window.location.href = data.data.redirect;
        }

        if (data.data?.resetForm !== false) {
            resetForm(form);
        }

        modals.closeModal();

        if (data.errors[0]?.message) {
            modalMessage(data.errors[0].message);
        } else {
            const contentForm = document.querySelector('.js-dso-form-content');

            createDsoTimer(contentForm)
            contentForm.classList.add('submited');
        }
    })

    function createDsoTimer(container) {
        const deadline = new Date(Date.now() + 5 * 1000);
        const timerElement = container.querySelector('.js-dso-timer');

        timer();
        const timerId = setInterval(timer, 1000);

        function timer() {
            const diff = deadline - Date.now();

            if (diff > 0) {
                timerElement.textContent = (diff / 1000).toFixed(0);
            } else {
                clearInterval(timerId)
                container.classList.remove('submited');
            }
        }

        return timerId;
    }
}
